import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { GaIconModule } from 'gain-lib/icon';

import { SideNavigationComponent } from './side-navigation.component';

@NgModule({
  declarations: [SideNavigationComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatDividerModule,
    MatTreeModule,
    GaIconModule,
  ],
  exports: [SideNavigationComponent],
})
export class GaSideNavigationModule {}
